<template>
  <section class="category-menu category-menu__full" v-if="tags?.length">
   	<h3 class="section-title">Tags</h3>
	<hr aria-hidden="true" class="devider"/>
      <div class="category-menu__list-wrap">
        <ul class="category-menu__list">
          <li
            v-for="(tag, index) in tags" :key="index"
            class="category-menu__item"
          >
            <a :href="tag.url" class="category-menu__link"
            >
              {{ tag.name }} 
            </a>
          </li>
        </ul>
   
    </div>
  </section>
</template>

<script setup lang="ts">
import {ref, Ref} from "vue";

interface Tag {
  url: string,
  name: string
}
const tags: Ref<Tag[]> = ref((window as any).tags as Tag[])

</script>